import { promiseTimeout } from '@vueuse/core';

export function useProductPage() {
  async function hideProductPage(page: HTMLBodyElement, keepPosition = false) {
    // Wait 100 ms for the rest of the page to be loaded
    await promiseTimeout(100);
    page.style.overflowY = 'hidden';
    page.style.touchAction = 'none';
    page.style.overscrollBehavior = 'none';
    page.style.position = keepPosition ? 'initial' : 'fixed';
  }

  function showProductPage(page: HTMLBodyElement) {
    page.style.overflowY = 'scroll';
    page.style.touchAction = 'auto';
    page.style.overscrollBehavior = 'auto';
    page.style.position = 'initial';
  }

  return {
    hideProductPage,
    showProductPage,
  };
}
